// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1228":"32c3b31e","4383":"f1a78968","6295":"ff448313","8070":"32c3b31e","9188":"a519d156"}[chunkId] + ".chunk.css";
};